export const ORG_KEY_FIELD_MAPPING = {
  aadhar: 'proof_data',
  gst: 'proof_data',
  pan: 'proof_data',
  pan_registered: 'alternate_proof_data'
};

export const GROUPED_FIELDS = [
  ['contact_first_name', 'note'],
  ['company_name', 'address_line_1', 'state'],
  ['aadhar'],
  ['pan'],
  ['gst'],
];

export const ADDRESS_FIELDS = ['address_line_1', 'state'];
